function setupSubscriptionEventListeners() {
  if (window.glassifySubscriptionPopupReady) return;
  window.glassifySubscriptionPopupReady = true;
  let opener;
  const popup = () => document.querySelector('.subscribe-save-popup');
  const overlay = () => document.querySelector('.cart-dark-overlay');
  const close = () => {
    popup()?.classList.remove('display-flex');
    popup()?.classList.add('display-none');
    overlay()?.classList.remove('display-block');
    overlay()?.classList.add('display-none');
    if (opener?.isConnected) opener.focus({preventScroll:true});
  };
  document.addEventListener('click', event => {
    const trigger = event.target.closest('.subscription-product-popup-link, .learn-more-subscribe-save, .suscripcion-popup-link');
    if (trigger) {
      event.preventDefault();
      opener = trigger;
      popup()?.classList.remove('display-none');
      popup()?.classList.add('display-flex');
      overlay()?.classList.remove('display-none');
      overlay()?.classList.add('display-block');
      popup()?.querySelector('.gc-popup-close')?.focus({preventScroll:true});
    } else if (event.target.closest('.gc-subscription-popup .gc-popup-close') || event.target === overlay()) {
      close();
    }
  });
  document.addEventListener('keydown', event => {
    const modal = popup();
    if (!modal?.classList.contains('display-flex')) return;
    if (event.key === 'Escape') { event.preventDefault(); event.stopImmediatePropagation(); close(); }
    if (event.key !== 'Tab') return;
    const controls = [...modal.querySelectorAll('button, a[href], [tabindex="0"]')].filter(el => el.getClientRects().length);
    const first = controls[0], last = controls[controls.length - 1];
    if (event.shiftKey && document.activeElement === first) { event.preventDefault(); last?.focus(); }
    else if (!event.shiftKey && document.activeElement === last) { event.preventDefault(); first?.focus(); }
  }, true);
}
document.addEventListener('DOMContentLoaded', setupSubscriptionEventListeners);
window.setupSubscriptionEventListeners = setupSubscriptionEventListeners;
if (document.readyState !== 'loading') setupSubscriptionEventListeners();
